/** App-side content library: the build plugin (scripts/content-plugin.ts) parses the markdown files and drops missing facts. */
import { LIBRARY_DATA } from "virtual:techtail-content";
import { KIND_BASE, contentLang, pieceFor, piecePath, type PieceGroup, type PieceKind } from "./shared";
import { LANGS, type Lang } from "@/seo/routes";

export const LIBRARY: PieceGroup[] = LIBRARY_DATA;

export const toLang = (l?: string): Lang => ((LANGS as readonly string[]).includes(l ?? "") ? (l as Lang) : "es");

/** Finds a piece by its slug in any language. */
export const findPiece = (kind: PieceKind, slug: string) =>
  LIBRARY.find((g) => g.kind === kind && Object.values(g.byLang).some((p) => p!.slug === slug));

export const listPieces = (kind: PieceKind) => LIBRARY.filter((g) => g.kind === kind);

/**
 * Maps an internal path to the current language: strips any language prefix and,
 * for resources/cases, swaps the slug for the one in `lang`. Returns a path without prefix.
 */
export function localizeContentPath(path: string, lang: Lang): string {
  const clean = path.replace(/^\/(es|en|it|de|fr)(?=\/|$)/, "") || "/";
  const m = clean.match(/^\/(recursos|casos)\/([^/?#]+)(.*)$/);
  if (!m) return clean;
  const kind = (Object.entries(KIND_BASE).find(([, b]) => b === m[1])?.[0] ?? "recurso") as PieceKind;
  const g = findPiece(kind, m[2]);
  return g ? `/${piecePath(g, lang)}${m[3]}` : clean;
}

export { contentLang, pieceFor, piecePath };
